import { CustomColumnProps } from '@ihsm/ui-shared';

export const columns: CustomColumnProps[] = [
  {
    name: 'positionId',
    title: 'Position Id',
  },
  {
    name: 'name',
    title: 'Name',
  },
  {
    name: 'assetClass',
    title: 'Asset Class',
  },
  {
    title: 'Instrument Type',
    name: 'instrumentType',
  },
  {
    title: 'Local Currency',
    name: 'localCurrency',
  },
  {
    title: 'PV',
    name: 'pv',
    columnType: 'currency',
  },
];

export const mappingTableColumns: CustomColumnProps[] = [
  {
    name: 'portfolioId',
    title: 'Portfolio Id',
  },
  {
    name: 'name',
    title: 'Name',
  },
  {
    name: 'type',
    title: 'Type',
  },
  { name: 'benchmarkId', title: 'Benchmark ID' },
  { name: 'benchmarkName', title: 'Benchmark Name' },
  {
    title: 'Currency',
    name: 'currency',
  },
  {
    title: 'NAV',
    name: 'nav',
    columnType: 'currency',
  },
];
